/**
 * Whether this page is a manager's hidden observation of a call:
 * manager-call-observer.html embeds the room with a receive-only observer room
 * token in its `jwt` parameter.
 *
 * Such a page is never the browser's saved account. It opens no queue socket,
 * reports no room entry or departure, registers no device handoff, sends no
 * call telemetry and announces no visual role, so the call never counts the
 * observer as a party, a member or "back", and nobody in it is told anything
 * by this page. Presentation only: the media server verifies the token.
 *
 * Dependency-free so the queue service and middleware can ask it early.
 */
let observerPageSeen = false;
function tokenRole(token) {
    const payload = token.split('.')[1];
    if (!payload || typeof atob !== 'function') {
        return undefined;
    }
    const parsed = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    const context = parsed && typeof parsed === 'object' ? parsed.context : undefined;
    const user = context && typeof context === 'object' ? context.user : undefined;
    return user && typeof user === 'object' ? user.role : undefined;
}
/**
 * @returns {boolean} True for an observer room page. Once seen, it stays true
 * for the life of the page, even if the token later leaves the address.
 */
export function isObserverRoomPage() {
    if (observerPageSeen) {
        return true;
    }
    try {
        const search = typeof window === 'undefined' ? undefined : window.location?.search;
        const token = typeof search === 'string' && search ? new URLSearchParams(search).get('jwt') : null;
        observerPageSeen = Boolean(token) && tokenRole(String(token)) === 'observer';
    }
    catch {
        observerPageSeen = false;
    }
    return observerPageSeen;
}
